import { Paper } from '@mui/material';
import { LAYOUT } from '@/constants/layout';

interface CentralFrameProps {
  children: React.ReactNode;
}

const CentralFrame = ({ children }: CentralFrameProps) => {
  return (
    <Paper sx={{ 
      p: LAYOUT.PADDING.MEDIUM / 8,
      height: '100%',
      overflow: 'auto'
    }}>
      {children}
    </Paper>
  );
};

export default CentralFrame; 